import React, { Component } from 'react'

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  ResponsiveContainer,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts'

import {
  Container,
} from 'semantic-ui-react'

class Graph extends Component {
  render() {
    return (
      <div className="base">
        <Container text style={{ marginTop: '2em' }}>
          <ResponsiveContainer width="100%" height="100%" minWidth={400} minHeight={300}>
            <LineChart width={400} height={200} data={this.props.data}>
              <CartesianGrid strokeDasharray="3 3" />
              <Tooltip />
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis yAxisId="left" />
              {/*<YAxis yAxisId="right" orientation="right" />*/}
              {/*<Legend />*/}
              <Line yAxisId="left" type="monotone" dataKey="pdf" stroke="#8884d8" activeDot={{ r: 8 }} />
              {/*<Line yAxisId="right" type="monotone" dataKey="cdf" stroke="#82ca9d" />*/}
            </LineChart>
          </ResponsiveContainer>
        </Container>
      </div>
    )
  }
}

export default Graph;
